import { Box, CircularProgress } from '@mui/material';
import AreYouSureDelete from '@app/components/AreYouSureDelete';
import ImageDialog from '@app/components/ImageDialog';
import ProductFormPage from '@app/components/ProductFormPage';
import { ImagesRow } from '@app/components/ProductFormPage/styled';
import RenderImagesByBackendData from '@app/components/RenderImagesByBackendData';

import { useEditProductLogic } from './useEditProductLogic';
import { EditProductSate, IUpdateProductFormData } from './types';

const EditProduct = () => {
  const {
    methods,
    previews,
    imageUrl,
    isLoading,
    isSuccess,
    receivedImagesFromBackend,
    largeImageMessage,
    isDeleteModalOpen,
    firebaseImageForProcess,
    actionOnImageString,
    isViewImageModalOpen,
    onSubmit,
    setState,
    handleDeleteBase64Image,
    onChangeImageUploadInput,
    handleDeleteImageFromFirebase,
  } = useEditProductLogic();

  if (isLoading && !receivedImagesFromBackend) {
    return (
      <Box sx={{ display: 'grid', minHeight: '300px', placeItems: 'center' }}>
        <CircularProgress />
      </Box>
    )
  }

  const existingImages = receivedImagesFromBackend?.length
    ? (
      <ImagesRow>
        {receivedImagesFromBackend.map((file) => (
          <RenderImagesByBackendData
            key={file.id}
            file={file}
            imagesLength={receivedImagesFromBackend.length}
            setState={setState}
          />
        ))}
      </ImagesRow>
    )
    : undefined;

  return (
    <>
      <ProductFormPage<IUpdateProductFormData, EditProductSate>
        title="Update Product"
        submitLabel="Update"
        submittingLabel="Updating..."
        methods={methods}
        previews={previews}
        setState={setState}
        isSubmitting={isLoading}
        isSuccess={isSuccess}
        largeImageMessage={largeImageMessage}
        existingImages={existingImages}
        onSubmit={onSubmit}
        onChangeUpload={onChangeImageUploadInput}
      />
      <AreYouSureDelete
        open={isDeleteModalOpen}
        onClose={() => {
          setState((prev) => ({ ...prev, isDeleteModalOpen: false }))
        }}
        onDelete={() => {
          if (firebaseImageForProcess.id) {
            handleDeleteImageFromFirebase()

            return;
          }

          handleDeleteBase64Image(actionOnImageString)
        }}
      />
      <ImageDialog
        isOpen={isViewImageModalOpen}
        url={imageUrl || actionOnImageString}
        onClose={() => {
          setState((prev) => ({ ...prev, isViewImageModalOpen: false, imageUrl: '' }))
        }}
      />
    </>
  );
};

export default EditProduct;
